// extracted by mini-css-extract-plugin
export default {"root":"CounterofferList_root__sC8+o","wrapper":"CounterofferList_wrapper__ZlPtX","items":"CounterofferList_items__lEokh","more":"CounterofferList_more__JhH3U"};